import { Search, VisibilityRounded,CloseRounded as CloseIcon } from "@mui/icons-material";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { CustomAutoComplete, InputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, sortFunctions } from "../../utils/constants";










const ModalDetalleProducto = ({
  isVisible,
  Criterios=[],
  productName,
  unidad_medida,
  OnCloseModalDetalle
})=>{

  const [criteriosOrdered,setCriteriosOrdered] = useState([]);


  useEffect(()=>{

    OrderDataToPrint();
  },[Criterios]);

  let OrderDataToPrint = ()=>{
   let NuevosCriterios = [];
    console.log({Criterios});
   const IsKeyInList = (key)=>{

   return  NuevosCriterios.findIndex( Ncriterio => Ncriterio.label === key );
  }
  Criterios.forEach(crt=>{
      let IndexItem = IsKeyInList(crt.descripcion_plan) ;
    if ( IndexItem !== -1){

      NuevosCriterios[IndexItem].SubItems.push({
        label:crt.descripcion_plan,
        value:`${crt.cod_mayor}+${crt.cod_plan}`
      });

    }else{

      NuevosCriterios.push({
        key:`${crt.descripcion_plan}-${crt.cod_mayor}-${crt.cod_plan}`,
        label:String(crt.descripcion_plan).toLowerCase(),
        SubItems:[{
          label:crt.descripcion_mayor,
          value:`${crt.cod_mayor}+${crt.cod_plan}`
        }]
      });

    }

  });
  setCriteriosOrdered(NuevosCriterios);
  console.log({NuevosCriterios});
  }

  return (
    <Dialog
     open={isVisible}
     maxWidth="md"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} >
      <Grid container >
        <Grid item sm={10} md={10}  >
          <Typography variant="h6"  alignContent="center" textAlign="left" >
              {productName} {unidad_medida? '- '+unidad_medida:''}
        </Typography>
      </Grid>
        <Grid item sm={2} md={2} alignContent="center" textAlign="center" >
          <IconButton
            aria-label="close"
            onClick={OnCloseModalDetalle}
            sx={{
              fontWeight:"bold",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      
    </DialogTitle>
    <DialogContent>
          <Grid container >
            <Grid  item sx={12} md={12} >
             <Typography variant="subtitle1" >
                Criterios de clasificacion
             </Typography>
            </Grid>
            <Grid container item sx={12} md={12} >
              {
                criteriosOrdered.map( criterioOrdered=> <Grid key={criterioOrdered.key} item sm={4} md={4} >
                      <CustomAutoComplete
                       multiple
                       disabled
                       id="tags-standard"
                       options={criterioOrdered.SubItems}
                       getOptionLabel={(option) => option.label}
                       isOptionEqualToValue={(option,value)=>{
                       
                        
                        return option.value === value.value;
                       }}
                       defaultValue={criterioOrdered.SubItems}
                       renderInput={(params) => (
                         <TextField
                         
                           {...params}
                           variant="standard"
                           label={criterioOrdered.label}
                          
                         />
                       )}
                      />
                  </Grid> )
              }
             
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={OnCloseModalDetalle} >OK, Cerrar</Button>
        </DialogActions>
    </Dialog>
  )

}










const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestroProveedores = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [sortQuery,setSortQuery] = useState({});


    useEffect(()=>{

      loadProducts();


    },[]);

    useEffect(()=>{

      if ( Object.keys(sortQuery).length > 0 ){
        console.log({sortQuery});
        let sortedItems = [];
        if (sortQuery.dataType === 'string'){
          sortedItems  = [...sortFunctions.sortString(dataSetProdctos,sortQuery.key,sortQuery.sortValue)];
        }else{
          sortedItems  = [...sortFunctions.sortNumber(dataSetProdctos,sortQuery.key,sortQuery.sortValue)];
        }
        setDataSetProductos(sortedItems);
      }
     

    },[sortQuery]);

    useEffect(()=>{
      setSortQuery({});
      loadProducts( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);
    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/obtener-proveedores-paginacion",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
      
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setProductoSeleccionado(product || {});
    }
    const onCloseModalDetalle = ()=>{
      setIsVisibleModalDetalle(false);
    }
    const setSortLabel = (key,dataType)=>{
       setSortQuery({
        key:key,
        sortValue:sortQuery.key === key?(sortQuery.sortValue === 'ASC'?'DESC':"ASC"):"ASC",
        dataType
       });
    }
    
    const SortLabelRender =  props=> <TableSortLabel
    active={ sortQuery.key === props.keyValue  }
    onClick={e=>setSortLabel( props.keyValue,props.typeRow )}
    direction={(sortQuery.key === props.keyValue? sortQuery.sortValue:'').toLowerCase() }
    >{props.label}</TableSortLabel>;
  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:SortLabelRender,
       bodyRender:(props)=>props.value,
       typeRow:"number",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"CODIGO ERP",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"razon_social",
        keyValue:"razon_social",
        label:"Razon social",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nit",
        keyValue:"nit",
        label:"Nit",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"estado",
        keyValue:"ind_estado",
        label:"Estado",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"email",
        keyValue:"email",
        label:"Correo",
        headerRender:SortLabelRender,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
/*        {
      
        key:"email",
        keyValue:"email",
        label:"Ver detalle",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<VisibilityRounded/>} >Ver</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       }, */  
    ];

    return (<>
{/*     {
      isVisibleModalDetalle &&
      <ModalDetalleProducto
      isVisible={isVisibleModalDetalle}
      productName={productoSeleccionado.descripcion}
      unidad_medida={productoSeleccionado.unidad_medida_nombre}
      Criterios={productoSeleccionado.detalle}
      OnCloseModalDetalle={onCloseModalDetalle}
      />
    } */}
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar proveedor"
              inputType="text"
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender {...colum} label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}